import { Box, Fade, useTheme } from "@mui/material";
import { FleetManagmentTable } from "./FleetManagementTable.component";

/**
 * @version 0.1.0
 */
export function FleetManagment() {
  const theme = useTheme();

  return (
    <Fade in>
      <Box sx={{ "& > *": { margin: theme.spacing(1) } }} data-testid="fleet-mgmt-parent">
        <FleetManagmentTable isEditable={true} />
      </Box>
    </Fade>
  );
}
